export enum OfferType {
  BUY_X_PAY_Y = "BUY_X_PAY_Y",
  QUANTITY_PRICE = "QUANTITY_PRICE",
  FIXED_PRICE = "FIXED_PRICE",
  PERCENTAGE = "PERCENTAGE",
  COMBO = "COMBO",
}
